import * as React from "react";
import PropTypes from "prop-types";
import Head from "next/head";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { CacheProvider } from "@emotion/react";
import theme from "../src/theme";
import "../src/css/Global.css";
import createEmotionCache from "../src/createEmotionCache";
import { ReactQueryDevtools } from "react-query/devtools";
import { useQueryClient, QueryClient, QueryClientProvider } from "react-query";
import AuthLayout from "../components/layouts/AuthLayout";
import CookieConsent, { Cookies } from "react-cookie-consent";
import { AuthContextProvider } from "../context/AuthProvider";
import PrivateRoute from "../components/Protected/ProtectedRoute";
import toast, { Toaster } from "react-hot-toast";


const queryClientConfig = {
  defaultOptions: {
    queries: {
      retry: 3,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      // refetchOnReconnect: false
    },
  },
};
const queryClient = new QueryClient(queryClientConfig);

// Client-side cache, shared for the whole session of the user in the browser.
const clientSideEmotionCache = createEmotionCache();

export default function MyApp(props) {
  const { Component, emotionCache = clientSideEmotionCache, pageProps } = props;
  const publicRoutes = [
    "/login",
    "/register",
    "/reset",
    "/register/organization",
    "/confirmation",
    "/help/help-me",
    "/404",
    "/create-user",
    "/info/gift-aid",
    "/info/privacy",
    "/info/terms",
    "/admin/assets",
    "/admin/donees",
    "/admin/donors",
    "/admin/reports",
    "/admin/overview",
    "/",
    "/about",
    "/coming-soon",
    "/pricing",
    "/reset",
    "/reset/verification",
    "/reset/password",
  ];
  const getLayout = Component.getLayout || ((page) => page);
  return (
    <>
      <Head>
        <title>iDonatio</title>
      </Head>
      <CacheProvider value={emotionCache}>
        <QueryClientProvider client={queryClient}>
          <AuthContextProvider>
            <Head>
              <meta
                name="viewport"
                content="initial-scale=1, width=device-width"
              />
            </Head>
            <ThemeProvider theme={theme}>
              {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
              <CssBaseline />

              { getLayout(<Component {...pageProps} />)}

              <Toaster
                position="top-right"
                toastOptions={{
                  duration: 7000,
                  success: {
                    icon: (
                      <i
                        class="las la-check-circle la-lg"
                        style={{ color: "green" }}
                      ></i>
                    ),
                    style: {
                      background: "#F0FFF6",
                      border: "1px solid #C2FFDB",
                      zIndex: 20000000,
                    },
                  },
                  error: {
                    icon: (
                      <i
                        class="las la-times-circle la-lg"
                        style={{ color: "red" }}
                      ></i>
                    ),
                    style: {
                      background: "#FFF5F5",
                      border: "1px solid #FFD1D1",
                      zIndex: 20000000,
                    },
                  },
                }}
              />
            </ThemeProvider>
          </AuthContextProvider>
          {/* <ReactQueryDevtools initialIsOpen={false} /> */}
        </QueryClientProvider>
        <div className="cookie-overlay">
          <CookieConsent
            location="bottom"
            buttonText="Accept cookies"
            enableDeclineButton
            cookieName="accepted_cookies"
            // style={{ background: "#2962FF" }}
            declineButtonStyle={{
              color: "#2962FF",
              fontSize: "13px",
              background: "transparent",
              borderRadius: "0.5rem",
            }}
            buttonStyle={{
              color: "white",
              background: "#2962FF",
              borderRadius: "0.5rem",
            }}
            expires={150}
          >
            This website uses cookies to enhance the user experience.{" "}
          </CookieConsent>
        </div>
      </CacheProvider>
    </>
  );
}

MyApp.propTypes = {
  Component: PropTypes.elementType.isRequired,
  emotionCache: PropTypes.object,
  pageProps: PropTypes.object.isRequired,
};
